import { makeStyles } from 'tss-react/mui';

/** Matches `listItem` / `itemIcon` / `itemText` patterns in `NavDrawerItem.styles.ts`. */
const useFeedbackNavStyles = makeStyles<{ isIconOnly: boolean }>()(
  (theme, { isIconOnly }) => ({
    root: {
      alignItems: 'center',
      backgroundColor: 'transparent',
      border: 'none',
      borderRadius: 0,
      boxSizing: 'border-box',
      color: theme.new.color.text.secondary,
      columnGap: theme.new.spacing.medium,
      cursor: 'pointer',
      display: 'grid',
      font: 'inherit',
      gridAutoFlow: 'column',
      justifyContent: isIconOnly ? 'center' : 'start',
      margin: 0,
      marginInline: isIconOnly ? 'auto' : undefined,
      maxWidth: isIconOnly ? 'none' : '100%',
      minHeight: isIconOnly ? '48px' : '56px',
      padding: isIconOnly
        ? theme.new.spacing.medium
        : `${theme.new.spacing.medium} ${theme.new.spacing.large}`,
      textAlign: isIconOnly ? 'center' : 'left',
      width: isIconOnly ? 'auto' : '100%',
      '& svg': {
        color: 'inherit',
      },
      '&:hover': {
        backgroundColor: theme.new.color.brand[100],
      },
      '&:focus-visible': {
        outline: `2px auto ${theme.new.color.brandPrimary}`,
        outlineOffset: '1px',
      },
    },
    itemIcon: {
      alignItems: 'center',
      display: 'inline-flex',
      flexDirection: 'column',
      height: '22px',
      justifyContent: 'center',
      minWidth: '18px',
    },
    itemText: {
      color: 'inherit',
      cursor: 'pointer',
    },
  })
);

export default useFeedbackNavStyles;
